import * as React from "react";
import { useTranslation } from "react-i18next";
import { Box, Button, Container, Paper, Stack, Typography } from "@mui/material";
import { useCallback } from "react";
import { useNavigation } from "hooks/useNavigation";
import { ROUTES } from "utils/navigationUtils";
import { AuthUtils } from "utils/AuthUtils";

export const UnauthenticatedSubmissionsDisabledMessage: React.FC = () => {
  const { t } = useTranslation();
  const { navigateTo } = useNavigation();

  const signIn = useCallback(async () => {
    await AuthUtils.signIn();
  }, []);

  return (
    <Container maxWidth="md">
      <Paper elevation={3} sx={{ p: 4, mt: 10, borderRadius: 2 }}>
        <Typography variant="h5" component="h1" gutterBottom color="primary">
          {t("createProject.unsignedUser.unauthenticatedDisabled.title")}
        </Typography>

        <Typography
          variant="body1"
          paragraph
          dangerouslySetInnerHTML={{ __html: t("createProject.unsignedUser.unauthenticatedDisabled.message") }}
        />

        <Box sx={{ mt: 4, display: "flex", justifyContent: "center" }}>
          <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
            <Button variant="contained" color="primary" onClick={signIn}>
              {t("createProject.unsignedUser.unauthenticatedDisabled.signIn")}
            </Button>
            <Button variant="outlined" onClick={() => navigateTo(ROUTES.HOME)}>
              {t("createProject.unsignedUser.unauthenticatedDisabled.returnToHome")}
            </Button>
          </Stack>
        </Box>
      </Paper>
    </Container>
  );
};
